module.exports = __webpack_public_path__ + "img/ic_completed.fb30e11.png";